/** This event argument is used to create initial selection value! */
export class MultiEditSelectionItemCreationEventArgs<IT> {
  _dataCount: number;
  _firstData: IT;

  _hasMultipleValues: boolean;
  _hasEmptyValue: boolean;
  _hasAllEmpty: boolean;

  _defaultText: string;

  /**
   * If there's only a single selection in the entire initial array (so there's no multiple selection), then this function returns TRUE.
   * In this case the initial selection as the initial value is constructed from the first item within from the initial data array.
   */
  public get createFromData(): boolean {
    return this.dataCount && !this.hasMultipleValues;
  }

  //
  //
  //

  public get dataCount(): number {
    return this._dataCount;
  }

  /** @returns The 1st item from the initial data array - or undefined if no such exists! */
  public get firstData(): any {
    return this._firstData;
  }

  public get hasMultipleValues(): boolean {
    return this._hasMultipleValues;
  }

  public get hasEmptyValue(): boolean {
    return this._hasEmptyValue;
  }

  public get hasAllEmpty(): boolean {
    return this._hasAllEmpty;
  }

  /**
   * This value is used in case of multiple selections, along with a special key value signalizing that multi-selection.
   * @returns Returns the default text for multiple selection (or for multiple selection with some empty values).
   */
  public get defaultText(): string {
    return this._defaultText;
  }

  constructor(
    dataCount: number,
    firstData: any,
    hasMultipleValues: boolean,
    hasEmptyValue: boolean,
    hasAllEmpty: boolean,
    defaultText: string
  ) {
    this._dataCount = dataCount;
    this._firstData = firstData;
    this._hasMultipleValues = hasMultipleValues;
    this._hasEmptyValue = hasEmptyValue;
    this._hasAllEmpty = hasAllEmpty;
    this._defaultText = defaultText;
  }
}
